module.exports = __webpack_public_path__ + "static/img/ability-icon5.46b770c.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/ability-icon5.png
// module id = qRfe
// module chunks = 1